// Prevent pitch to zoom
document.addEventListener(
  "touchmove",
  (event) => {
    if (event.scale !== 1) {
      event.preventDefault();
    }
  },
  { passive: false }
);

export default function isTablet(size) {
  return parseInt(size.width) > 479;
}
